<template>
  <header class="nc-header" :class="{ 'nc-header--transparent': transparent }">
    <div class="nc-header__bar">
      <div class="nc-header__start">
        <slot name="start" />
      </div>
      <div class="nc-header__title">
        <slot name="title">
          <span v-if="title">{{ title }}</span>
        </slot>
      </div>
      <div class="nc-header__end">
        <slot name="end" />
      </div>
    </div>
    <!-- Breadcrumbs disabled: header title + back button provide sufficient context -->
    <!-- <NavBreadcrumbs v-if="!noBreadcrumbs" /> -->
    <slot />
  </header>
</template>

<script>
import NavBreadcrumbs from '@/components/NavBreadcrumbs.vue';

export default {
  name: 'NcHeader',
  components: { NavBreadcrumbs },
  props: {
    title: { type: String, default: '' },
    transparent: { type: Boolean, default: false },
    noBreadcrumbs: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.nc-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--nc-bg-card);
  color: var(--nc-text);
  padding-top: var(--nc-safe-area-top);
  flex-shrink: 0;
  border-bottom: 1px solid var(--nc-border);
}

.nc-header--transparent {
  background: transparent;
  border-bottom: none;
  color: var(--nc-text);
}

.nc-header__bar {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 12px;
  gap: 0;
}

.nc-header__start:not(:empty) {
  margin-left: -8px;
}

.nc-header__end:not(:empty) {
  margin-right: -8px;
}

.nc-header__start {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--nc-color-primary);
}

.nc-header__title {
  flex: 1;
  font-size: var(--nc-font-size-sm);
  font-weight: var(--nc-font-weight-bold);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--nc-text);
  padding: 0 4px;
  min-width: 0;
}

.nc-header__end {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--nc-color-primary);
}
</style>
